import { render, staticRenderFns } from "./AttributedPurchasesDrawer.vue?vue&type=template&id=1d4d05f6"
import script from "./AttributedPurchasesDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttributedPurchasesDrawer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports